import { useEffect } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { ThemeProvider } from 'styled-components';
import GlobalStyles from './style/global';
import theme from './style/theme';
import Urls from './constants/urls';
import { AppConfigProvider } from './providers/AppConfigProvider';
import { ModalProvider } from './providers/ModalProvider';
import Home from './pages/Home';
import Modal from './components/ModalCmp';
import { InitSentry } from './helpers/sentry';
import ASRouter from './pages/auto-showroom/ASRouter';
import VGRouter from './pages/virtual-gallery/VGRouter';
import WCRouter from './pages/winemakers-cut/WCRouter';
import RERouter from './pages/real-estate/RERouter';
import ESRouter from './pages/empty-showroom/ESRouter';
import CBRouter from './pages/campionBoat-room/CBRouter';
import MSRouter from './pages/music-studio/MSRouter';
import LRRouter from './pages/locker-room/LRRouter';
import VWRouter from './pages/auto-2/VWRouter';
import JHRouter from './pages/james-house/JHRouter';
import NWRouter from './pages/north-wind/NWRouter';
import STLBRouter from './pages/stl-blues/STLBRouter'
import ISRouter from './pages/ivyshop/ISRouter';
// import ARouter from './pages/arcade/ARouter';

InitSentry();

const App = () => {
  const [cookies, setCookie] = useCookies(['name']);

  useEffect(() => {
    if (!cookies.mantisXR) {
      setCookie('mantisXR', 'visitor', { path: '/' });
    } else {
      console.log("Welcome back to MantisXR!")
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <AppConfigProvider>
        <ModalProvider>
          <Modal />
          <Router>
            <Switch>
              <Route {...Urls.home}>
                <Home />
              </Route>
              <Route path={Urls.winemakersCut.root.path}>
                <WCRouter />
              </Route>
              <Route path={Urls.virtualGallery.root.path}>
                <VGRouter />
              </Route>
              <Route path={Urls.AutoShowroom.root.path}>
                <ASRouter />
              </Route>
              <Route path={Urls.emptyShowroom.root.path}>
                <ESRouter />
              </Route>
              <Route path={Urls.realEstate.root.path}>
                <RERouter />
              </Route>
              <Route path={Urls.campionBoatRoom.root.path}>
                <CBRouter />
              </Route>
              <Route path={Urls.musicStudio.root.path}>
                <MSRouter />
              </Route>
              <Route path={Urls.lockerRoom.root.path}>
                <LRRouter />
              </Route>
              <Route path={Urls.auto2.root.path}>
                <VWRouter />
              </Route>
              <Route path={Urls.jamesHouse.root.path}>
                <JHRouter />
              </Route>
              <Route path={Urls.northWind.root.path}>
                <NWRouter />
              </Route>
              <Route path={Urls.stlBlues.root.path}>
                <STLBRouter />
              </Route>
              <Route path={Urls.ivyShop.root.path}>
                <ISRouter />
              </Route>
              {/* <Route path={Urls.arcade.root.path}>
                <ARouter />
              </Route> */}
            </Switch>
          </Router>
        </ModalProvider>
      </AppConfigProvider>
    </ThemeProvider>
  );
}

export default App;
